import React from 'react'
import { MarkdownFramework } from '../../utilities'
import ExternalLink from '../ExternalLink'

const Markdown = (props = {}) => {
    const { children } = props

    return <MarkdownFramework
        components={{
            link: (props = {}) => {
                const { href, ...rest } = props
                return <ExternalLink href={href} {...rest} />
            }
        }}
    >
        {children}
    </MarkdownFramework>
}

export default Markdown